import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Errori benigni che non vanno loggati come errori applicazione:
 * - ResizeObserver loop: causato da iframe/widget di terze parti (es. TradingView)
 *   che ridimensionano in un singolo frame; non impatta l'app.
 * - ChunkLoadError su snowplow/tracker: script di analytics TradingView bloccati
 *   da ad-blocker (ERR_BLOCKED_BY_CLIENT); i widget funzionano comunque.
 */
const IGNORED_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
  'Loading chunk 19886 failed',
  'snowplow-embed-widget-tracker'
];

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const message =
      typeof error === 'object' && error !== null && 'message' in error
        ? String((error as { message?: unknown }).message)
        : '';
    const causeMessage =
      typeof error === 'object' && error !== null && 'cause' in error
        ? String((error as { cause?: unknown }).cause ?? '')
        : '';

    const combined = `${message} ${causeMessage}`;
    const shouldIgnore = IGNORED_MESSAGES.some((ignored) => combined.includes(ignored));

    if (shouldIgnore) {
      return;
    }

    console.error('Application error:', error);
  }
}
